import React, { Component } from 'react';
import { ArrowRight } from 'react-feather';
import { connect } from 'react-redux';
import { get } from 'lodash/fp';
import { initDefaultView } from 'actions/content/defaultView';
import supportsLocalStorage from 'utils/supportsLocalStorage';
import { routes } from 'constants/config';
import FeatureFlag from 'components/shared/FeatureFlag';
import { hasFeatureFlags } from 'utils/features';
import * as actions from '../../actions/shared/index/filter';
import IndexWindowLocation from '../shared/index/window_location';
import ContentHeader from './header';
import ContentFilters from './filters';
import ContentActionBar from './action_bar';
import ContentDataView from './data_view';
import IndexTable from '../shared/index/table';
import ContentTableBody from './table/body';
import ArchiveButton from '../shared/index/archive_button';
import { contentTableHeaders } from '../../constants/tableHeaders';
import Filter from '../shared/index/filters';
import DefaultContentView from './DefaultContentView';
import ContentToggle from './Journeys/ContentToggle';
import JourneysContent from './JourneysContent';

const filterArchiveType = type => {
  switch (type) {
    case 'lesson':
    case 'path':
      return type;
    case 'practice_containers':
      return 'practice/container';
    default:
      return null;
  }
};

class ContentIndex extends Component {
  constructor(props) {
    super(props);
    if (supportsLocalStorage) {
      props.initDefaultView();
    }

    this.hasLearningJourneys = hasFeatureFlags(['readiness-learning-journeys']);
  }

  state = {
    contentToggleIndex: 0,
  };

  get tableHeaders() {
    const { selectedContentType } = this.props;

    let tableHeaders = contentTableHeaders.default;
    if (selectedContentType === 'fresh_content') {
      tableHeaders = contentTableHeaders.content_freshness;
    }

    return tableHeaders;
  }

  updateContentToggleIndex = index => {
    if (this.hasLearningJourneys) {
      this.setState({ contentToggleIndex: index });
    }
  };

  render() {
    const { i18n, userCanArchiveContent, query, type, filterUpdateQuery } =
      this.props;

    const { contentToggleIndex } = this.state;

    const filteredArchiveType = filterArchiveType(type);

    return (
      <div className="Index">
        <IndexWindowLocation omitParam="per_page" />
        <ContentHeader i18n={i18n} />

        {this.hasLearningJourneys && (
          <ContentToggle
            updateToggleIndex={this.updateContentToggleIndex}
            toggleIndex={contentToggleIndex}
          />
        )}

        {contentToggleIndex === 0 ? (
          <>
            <FeatureFlag
              fallback={supportsLocalStorage && <DefaultContentView />}
            >
              <div className="Index-toolbar Index-toolbar--search p-16 bg-navy-dark fd-r m-jc-e">
                <Filter.Search
                  className="IndexFilter-improved-search"
                  improvedSearch
                  value={query}
                  submitCallback={updateQuery => filterUpdateQuery(updateQuery)}
                  pendoClassName="trk_input_readiness_content-search-bar"
                />
                <a
                  href={routes.CONTENT.SEARCH}
                  className="ml-12 ws-nw ai-c td-n c-white d-fi h-c-white IndexFilter-advanced-search trk_button_readiness_content-advanced-search-open"
                >
                  <span className="lh-24 fz-16 ff-ss">
                    {t('content.advanced_search')}
                  </span>
                  <ArrowRight className="ml-8" size={22} />
                </a>
              </div>
            </FeatureFlag>

            <ContentFilters
              improvedSearch
              className="trk_container_readiness_content-filters"
            />
            <ContentActionBar />
            <ContentDataView tableHeaders={this.tableHeaders}>
              <IndexTable
                tableHeaders={this.tableHeaders}
                className="trk_container_readiness_content-list"
              >
                <ContentTableBody />
              </IndexTable>
            </ContentDataView>
          </>
        ) : (
          <JourneysContent {...this.props} />
        )}

        {userCanArchiveContent && contentToggleIndex === 0 && (
          <ArchiveButton query={query} type={filteredArchiveType} />
        )}
      </div>
    );
  }
}

const mapStateToProps = ({ filter, data }) => ({
  userCanArchiveContent: get('meta.currentUser.canArchiveContent', data),
  selectedContentType: filter.type,
  query: filter.query,
  type: filter.type,
});

const mapDispatchToProps = {
  initDefaultView,
  filterUpdateQuery: actions.filterUpdateQuery,
};

export default connect(mapStateToProps, mapDispatchToProps)(ContentIndex);
